import React, { forwardRef } from 'react';

/**
 * ThreeDCanvas component - Handles the PlayCanvas canvas rendering
 * Separated from the main View3D component for better modularity
 */
const ThreeDCanvas = forwardRef(({ 
    showLoading, 
    inputView,
    className = '',
    ...canvasProps 
}, ref) => {
    return (
        <canvas 
            id="application-canvas" 
            ref={ref} 
            className={`w-full h-full object-center ${showLoading ? 'hidden' : ''} ${
                inputView ? 'rounded-lg' : ''
            } ${className}`}
            {...canvasProps}
        />
    );
});

ThreeDCanvas.displayName = 'ThreeDCanvas';

export default ThreeDCanvas; 